import { useEffect, useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import { CURRENCY_SYMBOL } from 'src/config';
import styles from './ReviewOrderItems.module.scss';
import CustomerReviewModal from '../../components/CustomerReviewModal';

const ReviewOrderItem = ({ items, item, triggerGetOrderByHash, orderDetails, index }) => {
  const loggedInUserReview =
    Array.isArray(item?.store_item_review_rating?.review_rating) &&
    item?.store_item_review_rating?.review_rating[0];

  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [rating, setRating] = useState(
    loggedInUserReview ? loggedInUserReview?.rating : 0
  );

  useEffect(() => {
    if (loggedInUserReview) setRating(loggedInUserReview?.rating);
  }, [loggedInUserReview]);

  const handleReviewModalOpen = () => setOpenReviewModal(true);

  const handleReviewModalClose = () => {
    triggerGetOrderByHash();
    setOpenReviewModal(false);
    setRating(loggedInUserReview?.rating);
  };

  return (
    <>
      <div
        className={styles.orderItem}
        style={{
          borderBottom: index !== items?.length - 1 ? '1.5px solid #e2e2e2' : '0px',
        }}
      >
        <div className="flex items-start pb16px">
          <img src={item?.thumbnail_url} width="64px" height="64px" />
          <div className="flex flex-column pl12px">
            <p className="mv0 fw5 f14px pb8px">{item?.item_name}</p>
            <p className="mv0 fw5 f14px">
              {CURRENCY_SYMBOL} {item?.discounted_price}
            </p>
          </div>
        </div>
        <div className="flex items-center pt16px">
          <div className="flex flex-column">
            <p className="mv0 fw5 f14px pb8px">
              {loggedInUserReview?.rating ? 'Your ratings' : 'Rate product'}
            </p>
            <ReactStars
              key={`stars_${rating}`}
              size={24}
              classNames={styles.gap}
              onChange={(rating) => {
                setRating(rating);
                handleReviewModalOpen();
              }}
              value={rating}
              count={5}
            />
          </div>
          <div className={styles.verticalLine} />
          <p className={styles.writeReview} onClick={handleReviewModalOpen}>
            {loggedInUserReview?.review ? 'Edit review' : 'Write a Review'}
          </p>
        </div>
      </div>
      <CustomerReviewModal
        open={openReviewModal}
        ratingFromProps={rating}
        onClose={handleReviewModalClose}
        product={item}
        loggedInUserReview={loggedInUserReview}
        order_id={orderDetails?.order_id}
        onSubmit={triggerGetOrderByHash}
      />
    </>
  );
};

const ReviewOrderItems = ({ items = [], triggerGetOrderByHash, orderDetails }) => (
  <section className={styles.reviewOrderItemsContainer}>
    {items?.map((item, idx) => (
      <ReviewOrderItem
        key={idx}
        index={idx}
        item={item}
        items={items}
        triggerGetOrderByHash={triggerGetOrderByHash}
        orderDetails={orderDetails}
      />
    ))}
  </section>
);

export default ReviewOrderItems;
